"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var index_1 = require("../index");

exports.headerHeight = 52;
exports.browserTabsHeight = 70;
var ViewSectionContainer = styled_components_1.default(function (_a) {
  var maxWidth = _a.maxWidth,
      width = _a.width,
      height = _a.height,
      activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["maxWidth", "width", "height", "activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    position: relative;\n    margin: 0 auto;\n    min-height: 100vh;\n"], ["\n    ", ";\n    position: relative;\n    margin: 0 auto;\n    min-height: 100vh;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width,
      height = _a.height;
  return setViewWrapperDimensions(activeBreakpoint, width, height);
});

function setViewWrapperDimensions(activeBreakpoint, screenWidth, screenHeight) {
  var gutter = core_1.getActiveGutterSize(activeBreakpoint);
  var width = screenWidth - 2 * gutter;
  var calculatedHeight = calculateViewWrapperHeight(screenHeight);
  var height = calculatedHeight - gutter - exports.headerHeight;
  return "\n        width: " + width + "px;\n        height: " + height + "px;\n    ";
}

function calculateViewWrapperHeight(screenHeight) {
  return screenHeight > index_1.minScreenHeight ? screenHeight : index_1.minScreenHeight;
}

exports.calculateViewWrapperHeight = calculateViewWrapperHeight;
exports.default = responsive_1.withResponsiveMeta(ViewSectionContainer);
var templateObject_1;